import { render } from "./AfterSale.vue?vue&type=template&id=2653a6d2"
import script from "./AfterSale.vue?vue&type=script&lang=js"
export * from "./AfterSale.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__